module.exports = __webpack_public_path__ + "static/img/yf.594c06c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/yf.jpg
// module id = DVZ0
// module chunks = 1